import i18n from 'i18n';
import validator from 'validator';

export const validateForm = (name: string, value: string): string => {
  let error = '';

  if (name === 'name') {
    error = validator.isEmail(value) ? i18n.t('formErrors.isEmail') : '';
  }

  return error;
};
